import clsx from "clsx";
import React, { useContext } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { PaymentContext } from "../../contexts/PaymentContext";
import { ShoppingCart } from "lucide-react";
import SectionTitle from "./SectionTitle";
import Price from "components/Price";
import Resume from "./Resume";

const useStyles = makeStyles((theme) => ({
  listWrapper: {
    position: "relative",
  },
  list: {
    position: "sticky",
    top: 90,
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    border: "4px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / .05)",
    marginBottom: "20px",
    padding: "16px",
    listStyle: "none",
  },
  listItem: {
    padding: 0,
    flexWrap: "wrap",
  },
  listItemTitle: {
    width: "100%",
  },
  simpleList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    color: "#676f7e",
    fontSize: "14px",
  },
  label: {
    color: "#676f7e",
    marginBottom: "8px",
    fontSize: "14px",
  },
  simpleListItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginBottom: "12px",
  },
  flexColumn: {
    flexDirection: "column",
    marginBottom: "16px",
  },
  simpleListItemHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#676f7e",
  },
  strong: {
    color: "#21242c",
  },
  svg: {
    width: "12px",
    height: "12px",
    marginTop: "4px",
  },
  svgBig: {
    width: "16px",
    height: "16px",
  },
  button: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "8px",
    color: "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    cursor: "pointer",
    border: "1px solid var(--gc-action)",
    backgroundColor: "var(--gc-action)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  progress: {
    color: "#fff",
  },
  noPadding: {
    padding: 0,
  },
}));
export default function DesktopSidebar(props) {
  const [paymentContext] = useContext(PaymentContext);
  const hasExtraPaymentServices = paymentContext.hasExtraPaymentServices;

  const {
    enableTagManager = false,
    nationTitle = "Paese",
    groupTitle = "Pacchetto",
    packageTitle,
    departureTitle = "Partenza",
    /*structureTitle = 'Struttura',*/
    structureTitle = "Selezione",
    programTypologyTitle = "Tipologia di programma",
    selectedGroup,
    selectedTurn,
    // alternativeGroup,
    // alternativeTurn,
    bonusValue,
    // contributoValue,
    appState,
    packageSelectorState,
    // alternativePsState,
    // priceToPay = 0,
    totalPrice = 0,
    visualTotalPrice = null,
    depositPrice = 0,
    hasPaymentError = false,

    onNext,
    sendBookingButtonLabel,
    isSubmitting,
    stepsByName,
  } = props;

  const { activeStep } = appState;

  const classes = useStyles();

  const isRecapStep = activeStep === stepsByName.RECAP;

  return (
    <Grid
      item
      sm={isRecapStep ? 12 : 4}
      container
      className={clsx("sidebar", isRecapStep && "sidebar-recap")}
    >
      <Grid item xs={12} className={classes.listWrapper}>
        <List className={`aside-list ${classes.list}`}>
          <ul className={classes.card}>
            <SectionTitle icon={<ShoppingCart />} label="Riepilogo ordine" />
            <Price depositPrice={hasExtraPaymentServices ? depositPrice : 0}>
              {isRecapStep && (
                <Resume
                  resumeVariant
                  hasPaymentError={hasPaymentError}
                  appState={appState}
                  packageSelectorState={packageSelectorState}
                  nationTitle={nationTitle}
                  selectedGroup={selectedGroup}
                  groupTitle={groupTitle}
                  selectedTurn={selectedTurn}
                  packageTitle={packageTitle}
                  departureTitle={departureTitle}
                  structureTitle={structureTitle}
                  programTypologyTitle={programTypologyTitle}
                  enableTagManager={enableTagManager}
                  summaryStepIndex={stepsByName.RECAP}
                  totalPrice={totalPrice}
                  bonusValue={bonusValue}
                  visualTotalPrice={visualTotalPrice}
                />
              )}
            </Price>
            <br />
            {!isRecapStep && (
              <button onClick={onNext} className={classes.button}>
                {isSubmitting ? (
                  <CircularProgress size={16} className={classes.progress} />
                ) : (
                  <>
                    {activeStep === stepsByName.RECAP - 1
                      ? sendBookingButtonLabel
                      : "Avanti"}
                  </>
                )}
              </button>
            )}
          </ul>
          {!isRecapStep && (
            <Resume
              hasPaymentError={hasPaymentError}
              appState={appState}
              packageSelectorState={packageSelectorState}
              nationTitle={nationTitle}
              selectedGroup={selectedGroup}
              groupTitle={groupTitle}
              selectedTurn={selectedTurn}
              packageTitle={packageTitle}
              departureTitle={departureTitle}
              structureTitle={structureTitle}
              programTypologyTitle={programTypologyTitle}
              enableTagManager={enableTagManager}
              summaryStepIndex={stepsByName.RECAP}
              totalPrice={totalPrice}
              bonusValue={bonusValue}
              visualTotalPrice={visualTotalPrice}
            />
          )}

          {!isRecapStep && (
            <button onClick={onNext} className={classes.button}>
              {isSubmitting ? (
                <CircularProgress size={16} className={classes.progress} />
              ) : (
                <>
                  {activeStep === stepsByName.RECAP - 1
                    ? sendBookingButtonLabel
                    : "Avanti"}
                </>
              )}
            </button>
          )}
        </List>
      </Grid>
    </Grid>
  );
}

DesktopSidebar.propTypes = {
  enableTagManager: PropTypes.bool,
  nationTitle: PropTypes.string,
  groupTitle: PropTypes.string,
  packageTitle: PropTypes.string.isRequired,
  departureTitle: PropTypes.string,
  structureTitle: PropTypes.string,
  programTypologyTitle: PropTypes.string,
  selectedGroup: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }),
  selectedTurn: PropTypes.shape({
    label: PropTypes.string.isRequired,
    contractid: PropTypes.string,
  }),
  bonusValue: PropTypes.number.isRequired,
  contributoValue: PropTypes.number.isRequired,
  appState: PropTypes.object.isRequired,
  packageSelectorState: PropTypes.object.isRequired,
  priceToPay: PropTypes.number,
  visualTotalPrice: PropTypes.number,
  hasPaymentError: PropTypes.bool,
};
